module.exports = __webpack_public_path__ + "img/male_pic.7a33cb37.png";